(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("browserfs"));
	else if(typeof define === 'function' && define.amd)
		define(["browserfs"], factory);
	else if(typeof exports === 'object')
		exports["Doppio"] = factory(require("browserfs"));
	else
		root["Doppio"] = factory(root["BrowserFS"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_9__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition